
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/lookinbody-web",
      function () {
        return require("private-next-pages/product/lookinbody-web.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/lookinbody-web"])
      });
    }
  